import { useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2 } from "lucide-react";
import { api, coverSrc, errMsg, fmtNum, fmtSize } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { FxFields, MixFields, ToolFields, UploadForm } from "./Fields";

const KINDS = {
  mixes: { title: "Mixes", Fields: MixFields, label: (x) => x.title, meta: (x) => `${x.genre} · ${fmtNum(x.plays)} escuchas · ${fmtNum(x.downloads)} descargas · ${fmtNum(x.likes)} me gusta` },
  tools: { title: "Herramientas", Fields: ToolFields, label: (x) => x.title, meta: (x) => `${x.category} · ${fmtSize(x.size)} · ${fmtNum(x.downloads)} descargas` },
  fx: { title: "Efectos", Fields: FxFields, label: (x) => x.name, meta: (x) => x.color },
};

const Row = ({ kind, item, onEdit, onDelete }) => (
  <div data-testid={`manage-row-${kind}-${item.id}`} className="flex items-center gap-3 py-3 border-b border-white/10">
    {kind === "mixes" && <div className="w-12 h-12 shrink-0 bg-[#0A1424] overflow-hidden">{item.cover_url && <img src={coverSrc(item.cover_url)} alt="" className="w-full h-full object-cover" />}</div>}
    {kind === "fx" && <span className="w-4 h-4 shrink-0" style={{ background: item.color }} />}
    <div className="min-w-0 flex-1"><p className="truncate">{KINDS[kind].label(item)}</p><p className="font-mono text-xs text-[#A8B3C4] truncate">{KINDS[kind].meta(item)}</p></div>
    <button data-testid={`edit-${kind}-${item.id}`} onClick={() => onEdit(item)} className="p-2 text-[#A8B3C4] hover:text-[#1FD1FF]" aria-label="Editar"><Pencil className="w-4 h-4" /></button>
    <button data-testid={`delete-${kind}-${item.id}`} onClick={() => onDelete(item)} className="p-2 text-[#A8B3C4] hover:text-white" aria-label="Eliminar"><Trash2 className="w-4 h-4" /></button>
  </div>
);

export const ManageList = ({ data, onChange }) => {
  const [editing, setEditing] = useState(null);

  const del = async (kind, item) => {
    if (!window.confirm(`¿Eliminar "${KINDS[kind].label(item)}"? Los fans dejarán de verlo.`)) return;
    try {
      await api.delete(`/admin/${kind}/${item.id}`);
      toast.success("Eliminado");
      onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const E = editing && KINDS[editing.kind];

  return (
    <div className="grid lg:grid-cols-3 gap-10">
      {Object.entries(KINDS).map(([kind, k]) => (
        <div key={kind} data-testid={`manage-${kind}`}>
          <h3 className="font-display text-4xl mb-2">{k.title} <span className="text-[#A8B3C4] text-2xl">{data[kind]?.length ?? 0}</span></h3>
          {(data[kind] || []).map((item) => <Row key={item.id} kind={kind} item={item} onEdit={(it) => setEditing({ kind, item: it })} onDelete={(it) => del(kind, it)} />)}
          {!data[kind]?.length && <p className="text-sm text-[#A8B3C4] py-4">Nada todavía.</p>}
        </div>
      ))}
      <Dialog open={!!editing} onOpenChange={(o) => !o && setEditing(null)}>
        <DialogContent data-testid="edit-dialog" className="bg-[#07101E] border-white/10 rounded-none max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-display text-4xl font-normal">Editar</DialogTitle>
            <DialogDescription className="text-[#A8B3C4]">Cambia lo que quieras. Los archivos que no elijas se mantienen igual.</DialogDescription>
          </DialogHeader>
          {editing && (
            <UploadForm key={editing.item.id} endpoint={`/admin/${editing.kind}/${editing.item.id}`} method="patch" testid="edit-save-button" label="Guardar cambios" resetOnDone={false}
              onDone={() => { setEditing(null); onChange(); }}>
              <E.Fields d={editing.item} edit />
            </UploadForm>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
